module.exports = __webpack_public_path__ + "static/media/B12.b408e70a.jpg";